import React from 'react'
import AppButton from "../../ui/AppButton";
import Alert from "@material-ui/lab/Alert";
import Modal from "@material-ui/core/Modal";
import Redirect from "../../helpers/Redirect";
import Session from "../../helpers/Session";
import Api from "../../helpers/Api";
import Env from "../../config/env";

class AlertPrivacyPolicy extends React.Component {

    state = {
        url: '',
    };

    handleAgree = async (agree) => {

        if (!this.props.executeAPI) {
            const agreePP = agree === 'S';
            this.props.updateAgreePP(agreePP);
            this.props.onCloseModal();
            return;
        }

        const userLogged = Session.getLogin();

        const params = {
            user: userLogged.terceroMail,
            type: 'PP',
            agree: agree,
            source: Env.ApplicationCode
        }
        const data = await Api.post(`${Env.UrlBackend}/privacy-policy/update`, params);
        if (data.success) {
            if (agree === 'S') {
                this.props.onCloseModal();
            } else {
                Session.logout();
                this.setState({
                    url: '/'
                });
            }
        }
    }

    render() {

        const {openModal, onCloseModal, disabledClose = true, showAgreeButton = true} = this.props;

        return (
            <div>
                <Redirect url={this.state.url}/>
                <Modal
                    open={openModal}
                    onClose={onCloseModal}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    disableBackdropClick={disabledClose}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                >
                    <Alert style={{textAlign: 'justify', width: '600px'}}
                           severity="info">

                        <div style={{height: '500px', overflowY: 'auto'}}>
                            <div style={{paddingRight: '20px'}}>
                                <h3 style={{textAlign: 'center'}}>POLITICA DE PRIVACIDAD</h3>

                                Esta política de privacidad es referente al uso que ELECTROHUILA S.A. E.S.P., le dará a
                                la
                                información personal que el usuario proporciona en este documento. Para ELECTROHUILA
                                S.A.
                                E.S.P.
                                la
                                información personal está conformada por datos tales como: nombre, número de
                                identificación,
                                dirección de domicilio, dirección de correspondencia, correo electrónico y números
                                telefónicos;
                                en
                                todos los casos se trata de datos privados que no están disponibles al público.
                                <br/><br/>
                                El acceso a la información personal registrada en este documento, está limitado sólo a
                                aquellos
                                empleados que en ELECTROHUILA S.A. E.S.P., se consideran administradores de información
                                y
                                que
                                necesitan tener contacto con esos datos para proporcionar los servicios de información
                                previstos
                                en
                                este documento.
                                <br/><br/>
                                ELECTROHUILA S.A. E.S.P., se abstendrá de vender la información personal de los clientes
                                y/o
                                usuarios que se registre mediante este documento, como también se negará a compartir
                                esta
                                información con cualquier persona natural o jurídica externa y no autorizada por nuestra
                                compañía,
                                salvo en el caso de exigencias legales o judiciales que las autoridades competentes
                                amparadas
                                por la
                                normatividad vigente en materia de administración de información, internet, comercio
                                electrónico,
                                contratación, privacidad, documento electrónico y delitos informáticos así lo requieren.
                                <br/><br/>
                                ELECTROHUILA S.A. E.S.P., después de comunicar la Política de Seguridad para el manejo
                                de la
                                información de los registros realizados en este documento y en sus bases de datos,
                                solicita
                                a
                                los
                                clientes y/o usuarios declarar su aceptación y entendimiento para proceder al
                                almacenamiento
                                de
                                los
                                mismos así:
                                <br/><br/>
                                Declaración de aceptación y entendimiento de la Política de Privacidad de ELECTROHUILA
                                S.A.
                                E.S.P.,
                                para el manejo de la información personal del cliente y/o usuario registrada en este
                                documento
                                y/o
                                en sus bases de datos

                                <br/><br/>
                                Quien suscribe éste documento:
                                <br/><br/>
                                1. Declara que conoce y acepta la Política de Privacidad de ELECTROHUILA S.A. E.S.P.
                                para el
                                manejo
                                de la información personal del cliente y/o usuario en sus bases de datos.
                                <br/>
                                2. Declara que la información registrada ha sido suministrada con su consentimiento
                                libre,
                                previo, expreso y que autoriza el uso y difusión de la misma para los fines previstos en
                                este
                                documento.
                                <br/>
                                3. Declara que la información registrada le pertenece, pues no se encuentra
                                suministrando
                                información de terceras personas, pues entiende que ello constituye una suplantación,
                                tipificada en el artículo
                                296 del Código Penal como falsedad personal.
                                <br/>
                                4. Declara que cada uno de los datos registrados son verdaderos y corresponden a los
                                consignados en los correspondientes documentos de identificación personal, motivo por el
                                cual puede demostrar su
                                veracidad en cualquier momento.
                            </div>
                        </div>

                        <table style={{width: '100%', textAlign: 'center'}}>
                            <tbody>
                            <tr>
                                <td>
                                    {
                                        showAgreeButton ?
                                            <span style={{padding: '5px'}}>
                                            <AppButton
                                                type='button'
                                                label='Si acepto'
                                                size='small'
                                                onClick={() => {
                                                    this.handleAgree('S')
                                                }}
                                            />
                                        </span> : null
                                    }

                                    <span style={{padding: '5px'}}>
                                    <AppButton
                                        type='button'
                                        label='No acepto'
                                        size='small'
                                        onClick={() => {
                                            this.handleAgree('N')
                                        }}
                                    />
                                </span>

                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </Alert>

                </Modal>
            </div>
        );
    }

}

export default AlertPrivacyPolicy

